/* global axios */

import ApiClient from './ApiClient';

const compactParams = (params = {}) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );
};

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params: compactParams(params) });
  }

  download(params = {}) {
    return axios.get(`${this.url}.csv`, {
      params: compactParams(params),
      responseType: 'blob',
    });
  }
}

export default new AuditLogs();
